import React, { useCallback, useContext, useEffect, useRef, useState, } from 'react';
import { useEventListener } from '@24i/player-utils-react';
import { PlayerUIContext } from '@24i/player-ui';
import { Circle } from './styled';
import { PlayerIcon } from '../Icons';
export const Feedback = ({ playerInstance, duration, className, styles, }) => {
    const { state: { relativeSeekValue, seekAction, dvrPoint }, } = useContext(PlayerUIContext);
    const [iconToBeDisplayed, setIconToBeDisplayed] = useState(null);
    const timeout = useRef();
    const showFeedback = useCallback((iconName) => {
        if (timeout.current)
            clearTimeout(timeout.current);
        setIconToBeDisplayed(null);
        setTimeout(() => {
            setIconToBeDisplayed(React.createElement(PlayerIcon, { style: Object.assign(Object.assign({}, styles.icon), { width: 70 }), "data-test": "Feedback-Icon", className: "Feedback-Icon", name: iconName }));
        });
        timeout.current = setTimeout(() => {
            setIconToBeDisplayed(null);
        }, duration);
    }, [timeout.current]);
    const onPause = useCallback(() => {
        showFeedback('onDark-control_pause');
    }, []);
    const onPlay = useCallback(() => {
        showFeedback('onDark-control_play');
    }, []);
    const onMutechanged = useCallback(({ muted }) => {
        showFeedback(muted ? 'onDark-control_volume_off' : 'onDark-control_volume_up');
    }, [playerInstance]);
    useEffect(() => {
        if (!relativeSeekValue && !dvrPoint)
            return;
        const hasAdvanced = relativeSeekValue > 0;
        const relativeSeekIcon = hasAdvanced
            ? 'onDark-control_forward10'
            : 'onDark-control_replay10';
        const absoluteSeekIcon = dvrPoint === 'end' ? 'onDark-backToLive' : 'onDark-restart';
        const iconName = seekAction === 'absolute' ? absoluteSeekIcon : relativeSeekIcon;
        showFeedback(iconName);
    }, [relativeSeekValue, seekAction, dvrPoint]);
    useEventListener('play', onPlay, playerInstance);
    useEventListener('pause', onPause, playerInstance);
    useEventListener('mutedchanged', onMutechanged, playerInstance);
    return (iconToBeDisplayed && (React.createElement(Circle, { style: styles.container, "data-test": "Feedback-Circle", className: `Feedback-Circle ${className}`, duration }, iconToBeDisplayed)));
};
Feedback.defaultProps = {
    duration: 1000,
    className: '',
    styles: {
        container: null,
        icon: null,
    },
};
//# sourceMappingURL=index.js.map